import { render, staticRenderFns } from "./UploadCSVFile.vue?vue&type=template&id=f50bbb28&scoped=true"
import script from "./UploadCSVFile.vue?vue&type=script&lang=js"
export * from "./UploadCSVFile.vue?vue&type=script&lang=js"
import style0 from "./UploadCSVFile.vue?vue&type=style&index=0&id=f50bbb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50bbb28",
  null
  
)

export default component.exports